import React from 'react';
import homeStyle from "./styles";
import { Avatar, Box, Typography, Button, Link, List, ListItem } from "@mui/material";

const OurPartners = (data) => {
  return (
   <Box sx={homeStyle.partnersSection}>
        <Box sx={homeStyle.partnersTitle}>
            <Typography variant="h1" sx={homeStyle.partnersTitleH1}>Our Partners</Typography>
        </Box>
        {/* <Box sx={homeStyle.partnersRow}>
            <Box sx={homeStyle.partnersTabs}>
                <Button variant="outlined" sx={[homeStyle.btnPartnerTab, homeStyle.btnPartnerActive]}>Funds</Button>
                <Button variant="outlined" sx={homeStyle.btnPartnerTab}>BlockChains</Button>
                <Button variant="outlined" sx={homeStyle.btnPartnerTab}>Angels</Button>
            </Box>
        </Box> */}
        <Box sx={homeStyle.partnersRow}>
            <List sx={homeStyle.clientList}>
                <ListItem><Box component="img" src="./images/partners/multicoin.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/gama.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/pravega.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/krafton.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/woodstock.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/polygon.png" /></ListItem>
                <ListItem><Box component="img" src="./images/partners/iosg.png" /></ListItem>
            </List>
        </Box>
   </Box>
  )
}
export default OurPartners